<template>
  <v-dialog width="1000px" :value="showDialog" @input="showDialog = false" persistent scrollable>
    <v-card>
      <v-toolbar class="kbGold" dark text>
        <div class="text-h6">Subir Imagenes de la categoría de productos</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="showDialog = false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-0">
        <div class="flex-column py-4">
          <h3 class="text-center">{{mainLabel}} de la categoría de productos</h3>
          <p class="text-center">Sube {{secondaryLabel}} de la categoría de productos</p>
          <p class="text-center">
            Sólo se permiten los formatos
            <b>.jpg</b>,
            <b>.jpeg</b>,
            <b>.webp</b>,
            <b>.svg</b> y
            <b>.png</b>. Cada foto debe ser de máximo 20 Mb
          </p>
        </div>
        <div class="flex-column text-center py-4" ref="productsCategoryPhotosForm">
          <v-col class="text-center" cols="12">
            <DropZoneFileUpload
              v-if="mounted"
              ref="dropZoneFileUpload"
              :hiddenInputContainer="$refs.productsCategoryPhotosForm"
              :acceptedFiles="acceptedFiles"
              :uploadMultiple="true"
              :maxFiles="5"
              headText="Arrastra y suelta los archivos en esta zona"
              @filesAdded="onFilePicked"
            />
            <v-col
              cols="12"
              v-else
            >
              <v-skeleton-loader
                type="list-item-two-line, image"
              ></v-skeleton-loader>
            </v-col>
          </v-col>
          <v-col cols="12" v-if="importedFiles.length > 0">
            <v-row justify="center">
              <v-col cols="12">
                <v-subheader class="text-center">Foto</v-subheader>
              </v-col>
              <v-col cols="12">
                <v-list>
                  <v-list-item v-for="(importedFile, i) in importedFiles" :key="i">
                    <v-list-item-action>
                      <v-icon>account_box</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>{{importedFile.name}}</v-list-item-title>
                    <v-list-item-action
                      style="cursor: pointer"
                      @click="removeFile(importedFile, i)"
                    >
                      <v-icon>clear</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-col>
        </div>
      </v-card-text>
      <v-divider class="my-1"></v-divider>
      <v-card-actions>
        <v-btn text color="error" @click="cancel()">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="importedFiles.length > 0"
          @click="removeAllFiles"
          text
          color="error"
          class="mx-2"
        >
          <v-icon left>delete</v-icon>Eliminar Selección
        </v-btn>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-btn
                color="kbGold"
                class="float-right"
                @click="submitUploadFiles()"
                :loading="loadingUploadImage"
                :disabled="!areFilesUploaded"
              >
                <span class="hidden-xs-only">Continuar</span>
              </v-btn>
            </div>
          </template>
          <span v-if="!areFilesUploaded">Ingresa por lo menos un archivo para continuar</span>
          <span v-else>Subir imágenes</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from '@/libs/rules'
import notifications from '@/libs/notifications'
import DropZoneFileUpload from '@/components/ui/DropZoneFileUpload'

export default {
  components: {
    DropZoneFileUpload
  },
  mounted () {
  },
  computed: {
    showDialog: {
      get () {
        return this.showUploadImageDialog
      },
      set (value) {
        this.$emit('toggleShowUploadImageDialog', value)
      }
    }
  },
  data () {
    return {
      acceptedFiles: '.svg,.png,.jpg,.jpeg,.webp',
      importedFiles: [],
      selectedInterests: [],
      areFilesUploaded: false,
      mounted: false,
      rules
    }
  },
  methods: {
    onFilePicked (files) {
      // event) {
      // const files = event.target.files
      // const files = this.$refs.fileInput.files
      // console.log('files')
      // console.log(files)
      if (files.length > 0) {
        for (var i = 0; i < files.length; i++) {
          let file
          try {
            file = files.item(i)
          } catch (__) {
            file = files[i]
          }
          // console.log('file')
          // console.log(file)
          // console.log(file.accepted)
          // while (file.status !== 'queued') {}
          if (file.accepted) {
            this.importedFiles.push(file)
          } else {
            notifications.error(`El archivo ${file.name} no fue aceptado`)
          }
        }
      }
    },
    removeFile (file, idx) {
      this.importedFiles.splice(idx, 1)
    },
    async submitUploadFiles () {
      const fd = new FormData()
      for (let i = 0; i < this.importedFiles.length; i++) {
        await fd.append(this.formFileFieldName, this.importedFiles[i])
      }
      // console.log(this.importedFiles)
      // dispatch upload photo
      console.log('Method To Dispatch Upload', this.methodToDispatchUpload)

      const success = await this.$store.dispatch(this.methodToDispatchUpload, { filesForm: fd })
      if (success) {
        this.cancel()
      }
    },
    removeAllFiles () {
      this.$refs.dropZoneFileUpload.removeAllFiles()
      this.importedFiles = []
    },
    cancel () {
      this.removeAllFiles()
      this.showDialog = false
    }
  },
  props: {
    showUploadImageDialog: {
      type: Boolean,
      required: true
    },
    loadingUploadImage: {
      type: Boolean,
      required: true
    },
    formFileFieldName: {
      type: String,
      required: true
    },
    methodToDispatchUpload: {
      type: String,
      required: true
    },
    mainLabel: {
      type: String,
      default: 'Foto'
    },
    secondaryLabel: {
      type: String,
      default: 'la foto'
    }
  },
  watch: {
    importedFiles (value) {
      this.areFilesUploaded = value.length > 0
    },
    showDialog (value) {
      if (value) {
        setTimeout(() => {
        // console.log(this.$refs.productsCategoryPhotosForm)
        // wait some time before it finish mounting $refs
          this.mounted = true
        }, 500)
      }
    }
  }
}
</script>
